import { render, staticRenderFns } from "./totalReport.vue?vue&type=template&id=fb33f83a&"
import script from "./totalReport.vue?vue&type=script&lang=js&"
export * from "./totalReport.vue?vue&type=script&lang=js&"
import style0 from "./totalReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports